import React, { useContext } from "react";
import {
  Grid,
  TextField,
  InputLabel,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  ButtonBase,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookAdSetContext from "../../../../context/facebook_profiles/adset/AdSetContext";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: "99%",
    border: "1px solid silver",
    borderRadius: 5,
    margin: "auto auto 0.8rem",
    paddingLeft: "0.5rem",
    paddingRight: "0.5rem",
  },
  removeBox: {
    textAlign: "right",
  },
  removeButton: {
    fontWeight: "bold",
    fontSize: "small",
    backgroundColor: "red",
    color: "white",
    width: "20px",
    height: "20px",
    padding: "4px",
    borderRadius: "3px",
    "&:focus": {
      outline: "none",
    },
  },
  checkbox: {
    padding: 5,
  },
}));

const AdSetForm = ({
  adset_id,
  adset_details,
  list_pixel,
  remove,
  handleDuplicate,
}) => {
  const classes = useStyles();

  const {
    list_countries,
    list_billing_event,
    list_optimization_goal,
    list_custom_event_type,
    list_spec_event_type,
    form_details,
    setFormDetails,
    form_errors,
    setFormErrors,
  } = useContext(FacebookAdSetContext);

  const adset_errors = form_errors[adset_id];

  const handleChange = (e) => {
    const id = e.target.id;
    let value = id === "countries" ? e.target.name : e.target.value;

    if (id === "countries") {
      if (e.target.checked && !adset_details.countries.includes(value)) {
        adset_details.countries.push(value);
        value = adset_details.countries;
      } else {
        value = adset_details.countries.filter((each) => each !== value);
      }
    }

    switch (id) {
      case "name":
        if (value.length < 1) {
          adset_errors[id] = "Name cannot be empty!";
        } else if (value.length > 50) {
          adset_errors[id] = "Name cannot be more than 50 characters!";
        } else {
          adset_errors[id] = "";
        }
        break;

      case "billing_event":
      case "optimization_goal":
      case "pixel_id":
      case "custom_event_type":
      case "spec_event_type":
        if (value) adset_errors[id] = "";
        break;

      case "countries":
        if (value.length === 0) {
          adset_errors[id] = "Select at least one country!";
        } else {
          adset_errors[id] = "";
        }
        break;

      default:
        break;
    }

    form_details[adset_id] = { ...adset_details, [id]: value };
    form_errors[adset_id] = adset_errors;
    setFormDetails(form_details);
    setFormErrors(form_errors);

    handleDuplicate();
  };

  return (
    <Grid item container spacing={1} className={classes.paper}>
      <Grid item container>
        <Grid item xs>
          <span
            style={{
              fontWeight: "bold",
              fontSize: 14,
            }}
          >
            {" "}
            {adset_details.name ? adset_details.name : "Ad Set"}{" "}
          </span>{" "}
        </Grid>
        <Grid item xs={1} className={classes.removeBox}>
          <ButtonBase
            name={adset_id}
            onClick={remove}
            focusRipple={true}
            className={classes.removeButton}
          >
            X{" "}
          </ButtonBase>{" "}
        </Grid>{" "}
      </Grid>
      <Grid item xs={4}>
        <TextField
          required
          fullWidth
          variant="outlined"
          size="small"
          margin="dense"
          label="Name"
          id="name"
          name="name"
          value={adset_details.name}
          onChange={handleChange}
          error={adset_errors.name ? true : false}
          helperText={adset_errors.name ? adset_errors.name : ""}
        />{" "}
      </Grid>
      <Grid item xs={4}>
        <TextField
          required
          fullWidth
          variant="outlined"
          select
          SelectProps={{
            native: true,
          }}
          size="small"
          margin="dense"
          label="Pixel ID"
          id="pixel_id"
          name="pixel_id"
          value={adset_details.pixel_id ? adset_details.pixel_id : "select"}
          onChange={handleChange}
          error={adset_errors.pixel_id ? true : false}
          helperText={adset_errors.pixel_id ? adset_errors.pixel_id : ""}
        >
          <option value="select" disabled>
            -- - select one-- -
          </option>{" "}
          {list_pixel.map((each) => {
            return (
              <option key={each.id} value={each.id}>
                {" "}
                {each.name}({each.id}){" "}
              </option>
            );
          })}{" "}
        </TextField>{" "}
      </Grid>
      <Grid item xs={4}>
        <TextField
          required
          fullWidth
          variant="outlined"
          select
          SelectProps={{
            native: true,
          }}
          size="small"
          margin="dense"
          label="Billing Event"
          id="billing_event"
          name="billing_event"
          value={
            adset_details.billing_event ? adset_details.billing_event : "select"
          }
          onChange={handleChange}
          error={adset_errors.billing_event ? true : false}
          helperText={
            adset_errors.billing_event ? adset_errors.billing_event : ""
          }
        >
          <option value="select" disabled>
            -- - select one-- -
          </option>{" "}
          {list_billing_event.map((each, index) => {
            return (
              <option key={index} value={each}>
                {" "}
                {each}{" "}
              </option>
            );
          })}{" "}
        </TextField>{" "}
      </Grid>
      <Grid item xs={4}>
        <TextField
          required
          fullWidth
          variant="outlined"
          select
          SelectProps={{
            native: true,
          }}
          size="small"
          margin="dense"
          label="Optimization Goal"
          id="optimization_goal"
          name="optimization_goal"
          value={
            adset_details.optimization_goal
              ? adset_details.optimization_goal
              : "select"
          }
          onChange={handleChange}
          error={adset_errors.optimization_goal ? true : false}
          helperText={
            adset_errors.optimization_goal ? adset_errors.optimization_goal : ""
          }
        >
          <option value="select" disabled>
            -- - select one-- -
          </option>{" "}
          {list_optimization_goal.map((each, index) => {
            return (
              <option key={index} value={each}>
                {" "}
                {each}{" "}
              </option>
            );
          })}{" "}
        </TextField>{" "}
      </Grid>
      <Grid item xs={4}>
        <TextField
          required
          fullWidth
          variant="outlined"
          select
          SelectProps={{
            native: true,
          }}
          size="small"
          margin="dense"
          label="Custom Event Type"
          id="custom_event_type"
          name="custom_event_type"
          value={
            adset_details.custom_event_type
              ? adset_details.custom_event_type
              : "select"
          }
          onChange={handleChange}
          error={adset_errors.custom_event_type ? true : false}
          helperText={
            adset_errors.custom_event_type ? adset_errors.custom_event_type : ""
          }
        >
          <option value="select" disabled>
            -- - select one-- -
          </option>{" "}
          {list_custom_event_type.map((each, index) => {
            return (
              <option key={index} value={each}>
                {" "}
                {each}{" "}
              </option>
            );
          })}{" "}
        </TextField>{" "}
      </Grid>
      <Grid item xs={4}>
        <TextField
          required
          fullWidth
          variant="outlined"
          select
          SelectProps={{
            native: true,
          }}
          size="small"
          margin="dense"
          label="Attribution Spec - Event Type"
          id="spec_event_type"
          name="spec_event_type"
          value={
            adset_details.spec_event_type
              ? adset_details.spec_event_type
              : "select"
          }
          onChange={handleChange}
          error={adset_errors.spec_event_type ? true : false}
          helperText={
            adset_errors.spec_event_type ? adset_errors.spec_event_type : ""
          }
        >
          <option value="select" disabled>
            -- - select one-- -
          </option>{" "}
          {list_spec_event_type.map((each, index) => {
            return (
              <option key={index} value={each}>
                {" "}
                {each}{" "}
              </option>
            );
          })}{" "}
        </TextField>{" "}
      </Grid>
      <Grid item xs={1}>
        <InputLabel shrink> Countries: </InputLabel>{" "}
      </Grid>
      <Grid item xs>
        <FormControl
          required
          error={adset_errors.countries ? true : false}
          component="fieldset"
        >
          <FormGroup row={true}>
            {" "}
            {Object.entries(list_countries).map(([key, name]) => {
              return (
                <FormControlLabel
                  key={key}
                  control={
                    <Checkbox
                      className={classes.checkbox}
                      // style={{ padding: 5 }}
                      color="primary"
                      id="countries"
                      name={key}
                      onChange={handleChange}
                      checked={
                        adset_details.countries.includes(key) ? true : false
                      }
                    />
                  }
                  label={name}
                />
              );
            })}{" "}
          </FormGroup>
          {adset_errors.countries && (
            <FormHelperText> {adset_errors.countries} </FormHelperText>
          )}{" "}
        </FormControl>{" "}
      </Grid>{" "}
    </Grid>
  );
};

export default AdSetForm;
